import { render, staticRenderFns } from "./AddTagsSidebar.vue?vue&type=template&id=7b207c86"
import script from "./AddTagsSidebar.vue?vue&type=script&lang=js"
export * from "./AddTagsSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports